import { useEffect } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import InstallFAB from "./components/install/InstallFAB";
import InstallModal from "./components/install/InstallModal";
import UpdatePrompt from "./components/UpdatePrompt";
import { lazy, Suspense } from "react";

// Code-split all non-Home routes
const Apply = lazy(() => import("./pages/Apply"));
const AdminCandidaturas = lazy(() => import("./pages/AdminCandidaturas"));
const Instalar = lazy(() => import("./pages/Instalar"));

const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    const setRealVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    setRealVh();

    window.addEventListener("resize", setRealVh);

    const handleOrientation = () => setTimeout(setRealVh, 300);
    window.addEventListener("orientationchange", handleOrientation);

    document.addEventListener("visibilitychange", setRealVh);

    window.addEventListener("focusin", setRealVh);
    window.addEventListener("focusout", setRealVh);

    return () => {
      window.removeEventListener("resize", setRealVh);
      window.removeEventListener("orientationchange", handleOrientation);
      document.removeEventListener("visibilitychange", setRealVh);
      window.removeEventListener("focusin", setRealVh);
      window.removeEventListener("focusout", setRealVh);
    };
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ScrollToTop />
        <UpdatePrompt />
        <InstallModal />
        <InstallFAB />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/apply" element={<Suspense fallback={null}><Apply /></Suspense>} />
          <Route path="/instalar" element={<Suspense fallback={null}><Instalar /></Suspense>} />
          <Route path="/admin/candidaturas" element={<Suspense fallback={null}><AdminCandidaturas /></Suspense>} />
          {/* Legacy redirects */}
          <Route path="/login" element={<Navigate to="/admin/candidaturas" replace />} />
          <Route path="/admin" element={<Navigate to="/admin/candidaturas" replace />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
};

export default App;
